import { render, staticRenderFns } from "./GroupStoragePanel.vue?vue&type=template&id=5e9e3a62&scoped=true"
import script from "./GroupStoragePanel.vue?vue&type=script&lang=ts"
export * from "./GroupStoragePanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9e3a62",
  null
  
)

export default component.exports